import TuneIcon from '@mui/icons-material/Tune';
import { Box, Divider, Typography, useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { CourseFilter, Programme } from '../../../services/type';
import DisciplineFilter from './DisciplineFilter';
import FiltersResult from './FiltersResult';
import ParticipantFilter from './ParticipantFilter';
import ReunionFilter from './ReunionFilter';
import { getRadientBG } from '../../../../../utils/display';

type Props = {
    filter: CourseFilter;
    setFilter: (filter: CourseFilter) => void;
    programme?: Programme;
};

const CourseFilters: FC<Props> = ({ filter, setFilter, programme }) => {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    if (!programme) return null;

    return (
        <Box
            sx={{
                width: '100%',
                height: isMobile ? '72vh' : '66vh',
                p: 0,
                display: 'flex',
                flexDirection: 'column',
                borderRadius: isMobile ? 0 : 3,
                border: isMobile ? '' : '2px solid',
                borderColor: 'primary.main',
                background: getRadientBG(),
                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* HEADER */}
            {!isMobile && (
                <Box
                    px={2}
                    py={1}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    borderBottom="2px solid"
                    borderColor="primary.dark"
                    bgcolor="primary.main"
                    color={'white'}
                >
                    <TuneIcon />
                    <Typography variant="h6" fontWeight={700}>
                        Filtres
                    </Typography>
                </Box>
            )}

            {/* RÉSUMÉ DES FILTRES ACTIFS */}
            <Box
                mx={2}
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap={1}
            >
                <FiltersResult
                    filter={filter}
                    programme={programme}
                    setFilter={setFilter}
                />
            </Box>

            {/* LISTE DES FILTRES (SCROLL) */}
            <Box
                flex={1}
                display={'flex'}
                flexDirection={'column'}
                overflow="auto"
                px={2}
                pb={1}
                mt={1}
                gap={2}
            >
                <Box display={'flex'} flexDirection={'column'} gap={1}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={700}
                        letterSpacing={0.5}
                        color="white"
                        sx={{ textTransform: 'uppercase' }}
                    >
                        Réunion
                    </Typography>
                    <ReunionFilter filter={filter} programme={programme} />
                </Box>
                <Divider />

                <Box display={'flex'} flexDirection={'column'} gap={1}>
                    <Typography
                        variant="subtitle1"
                        fontWeight={700}
                        letterSpacing={0.5}
                        color="white"
                        sx={{ textTransform: 'uppercase' }}
                    >
                        Discipline
                    </Typography>
                    <DisciplineFilter filter={filter} programme={programme} />
                </Box>
                <Divider />

                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    gap={1}
                    alignItems={'center'}
                >
                    <Typography
                        variant="subtitle1"
                        fontWeight={700}
                        letterSpacing={0.5}
                        color="white"
                        sx={{ textTransform: 'uppercase' }}
                    >
                        Participants
                    </Typography>

                    <ParticipantFilter programme={programme} />
                </Box>
                <Divider />
            </Box>
        </Box>
    );
};

export default CourseFilters;
